import React from "react";

export const Scope = (props) => {
  return (
    <div id="scope">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-7">
            <div>
              <h2>Integration Scope</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.data ? props.data.paragraph : "loading...",
                }}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-5">
            <img src="img/scope.png" className="img-responsive" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
